import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import * as styles from './styles.css';
import { NBSP } from '../../constants/symbols';

export interface IHeroBannerProps {
  subdomain: string;
}

export const HeroBanner: React.FC<IHeroBannerProps> = ({ subdomain }: IHeroBannerProps) => {
  return (
    <div {...mergeStyles(styles['container'], styles[`background-for--${subdomain}`])}>
      <h1 className={styles['title']}>Узнайте рыночную стоимость{NBSP}недвижимости</h1>
      <div className={styles['overlay']} />
    </div>
  );
};

HeroBanner.displayName = 'HeroBanner';
